"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _store = require("./store");
Object.keys(_store).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _store[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _store[key];
    }
  });
});
var _options = require("./options");
Object.keys(_options).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _options[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _options[key];
    }
  });
});
var _Signature = require("./Signature");
var _Paths = require("./Paths");
var _jsxRuntime = require("react/jsx-runtime");
var _perfectFreehand = require("perfect-freehand");
Object.keys(_perfectFreehand).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _perfectFreehand[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _perfectFreehand[key];
    }
  });
});
var _utils = require("./utils");
Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});
var _excluded = ["children", "options", "renderPath", "defaultPoints"];
var Signature = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    options = _ref.options,
    renderPath = _ref.renderPath,
    defaultPoints = _ref.defaultPoints,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useReducer = (0, _react.useReducer)(_store.reducer, Object.assign({}, defaultPoints)),
    _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useReducer3 = (0, _react.useReducer)(_options.reducerOption, Object.assign((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _options.defaultOptions), {}, {
      renderPath: renderPath
    }), options)),
    _useReducer4 = (0, _slicedToArray2["default"])(_useReducer3, 2),
    stateOption = _useReducer4[0],
    dispatchOption = _useReducer4[1];
  (0, _react.useEffect)(function () {
    return dispatchOption((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, options), {}, {
      renderPath: renderPath
    }));
  }, [options, renderPath]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_store.PointerContext.Provider, {
    value: state,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_store.PointerDispatchContext.Provider, {
      value: dispatch,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Signature.Signature, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, props), {}, {
        ref: ref,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_options.OptionContext.Provider, {
          value: stateOption,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_options.OptionDispatchContext.Provider, {
            value: dispatchOption,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paths.Paths, {})
          })
        }), children]
      }))
    })
  });
});
var _default = exports["default"] = Signature;